import { UsersClearCurrentUserReducer } from './types';

export const usersClearCurrentUserReducer: UsersClearCurrentUserReducer = (
  state
) => {
  return {
    ...state,
    currentUser: undefined,
  };
};
